import type { AuthActor } from "@/features/auth/authSessionSchema";

export class WorkspaceLaunchScopeChangedError extends Error {
  constructor() {
    super("登录账号或组织已变化，本次旧对话不会发送，请重新输入");
    this.name = "WorkspaceLaunchScopeChangedError";
  }
}

const keyFor = (actor: AuthActor | null) => JSON.stringify([actor?.userId ?? "", actor?.activeOrganizationId ?? ""]);

// 身份一旦离开原范围，本次异步意图永久失效；A→B→A 不能复活旧回执。
export function createWorkspaceLaunchScopeGuard(expected: AuthActor | null, readActor: () => AuthActor | null, subscribe: (listener: () => void) => () => void) {
  const key = keyFor(expected);
  let changed = !expected?.userId || !expected.activeOrganizationId || keyFor(readActor()) !== key;
  const dispose = subscribe(() => { if (keyFor(readActor()) !== key) changed = true; });
  const isCurrent = () => !changed && keyFor(readActor()) === key;
  return { dispose, isCurrent, assertCurrent: () => { if (!isCurrent()) throw new WorkspaceLaunchScopeChangedError(); } };
}

export function workspacePendingSendBelongsTo(
  target: { conversationId: string; organizationId: string; shopBindingId: string; userId: string },
  current: { conversationId: string; organizationId: string; shopBindingId: string; userId: string },
) {
  return Boolean(
    target.conversationId && target.organizationId && target.userId &&
    target.conversationId === current.conversationId &&
    target.organizationId === current.organizationId &&
    target.shopBindingId === current.shopBindingId &&
    target.userId === current.userId,
  );
}
